const initialState = {
    arr: []
}

const medCertUploadRed = (state = initialState, action) => {
    switch(action.type){
        case 'MEDCERT_UPLOAD' : {
            return {
                ...state,
                arr: action.arr
            }
        }
        default: {
            return state
        }
    }
}

export default medCertUploadRed